import './index.css'
import * as React from 'react'
import BandagedHeadSvg from './assets/icons/bandaged-head.svg'
import NotFoundIllustration from 'components/error-page/assets/icons/not-found.svg'
import { Flex } from 'components/ds'
export default class ErrorPage extends React.Component<{
  icon: 'ERROR_PAGE_BANDAGE' | 'ERROR_PAGE_OUTAGE'
  title: string
  description: React.ReactNode
}> {
  static defaultProps: {
    icon: 'ERROR_PAGE_BANDAGE' | 'ERROR_PAGE_OUTAGE'
  } = {
    icon: 'ERROR_PAGE_OUTAGE',
  }

  render(): React.ReactElement<'div'> {
    let icon = null

    switch (this.props.icon) {
      case 'ERROR_PAGE_BANDAGE':
        icon = <BandagedHeadSvg className="ErrorPage_Icon" />
        break

      case 'ERROR_PAGE_OUTAGE':
        icon = <NotFoundIllustration className="ErrorPage_Icon" />
        break
    }

    return (
      <div className="ErrorPage_Block">
        <div className="ErrorPage_Content">
          <Flex justify="center">{icon}</Flex>
          <div className="text-9 font-bold leading-[var(--line-height-9)] tracking-[-0.4px] text-gray-12 text-center m-0">
            Sorry!
          </div>
          <div className="text-8 leading-[var(--line-height-8)] tracking-[-0.16px] text-gray-12 text-center m-0">
            {this.props.title}
          </div>
          <div className="text-5 leading-[var(--line-height-5)] tracking-[-0.08px] text-gray-12 text-center m-0">
            {this.props.description}
          </div>
        </div>
      </div>
    )
  }
}
